import { DatePickerPresetsOptions, DateRange } from '@clickcease/cc-client-components-lib'
import { add, startOfDay, startOfMonth } from 'date-fns'

import { RangeOptionKey } from './types'

const today = new Date()

const getRange: (from: Date) => DateRange = (from) => ({
  from,
  to: today,
})

export const baseRangeOptions: Record<
  Exclude<keyof typeof RangeOptionKey, 'CUSTOM'>,
  { value: DatePickerPresetsOptions; range: DateRange }
> = {
  TODAY: {
    value: 'today',
    get range() {
      return getRange(startOfDay(add(today, { days: -1 })))
    },
  },
  WEEK: {
    value: 'week',
    get range() {
      return getRange(startOfDay(add(today, { days: -7 })))
    },
  },
  MONTH: {
    value: 'month',
    get range() {
      const thisMonth = new Date(today.getFullYear(), today.getMonth(), 1)
      const firstDayOfThisMonth = startOfMonth(thisMonth)
      return {
        from: firstDayOfThisMonth,
        to: today,
      }
    },
  },
  THREE_MONTHS: {
    value: '3months',
    get range() {
      return getRange(startOfDay(add(today, { months: -3 })))
    },
  },
}

export const fullRangeOptions: Record<
  keyof typeof RangeOptionKey,
  { value: DatePickerPresetsOptions | 'custom'; range?: DateRange }
> = {
  ...baseRangeOptions,
  CUSTOM: {
    value: 'custom',
  },
} as const
